// src/features/automacaodeemails/components/AutomacaoEmailsLayout.jsx
import React from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import "../styles.css";

const ICONS = {
  home: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M3 10.5L12 3l9 7.5" />
      <path d="M5 10v10h14V10" />
    </svg>
  ),
  screens: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="3" width="20" height="14" rx="2" />
      <line x1="8" y1="21" x2="16" y2="21" />
      <line x1="12" y1="17" x2="12" y2="21" />
    </svg>
  ),
  automations: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  ),
  logs: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12,6 12,12 16,14" />
    </svg>
  ),
  settings: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  ),
  assets: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <circle cx="8" cy="8" r="2" />
      <path d="M21 15l-5-5L5 21" />
    </svg>
  ),
  plus: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  back: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12,19 5,12 12,5" />
    </svg>
  ),
};

const NAV_ITEMS = [
  { to: "/automacao-emails", label: "Visão geral", icon: ICONS.home, end: true },
  { to: "/automacao-emails/screens", label: "Telas", icon: ICONS.screens },
  { to: "/automacao-emails/automations", label: "Automações", icon: ICONS.automations },
  { to: "/automacao-emails/assets", label: "Assinaturas e imagens", icon: ICONS.assets },
  { to: "/automacao-emails/logs", label: "Envios", icon: ICONS.logs },
  { to: "/automacao-emails/settings", label: "Configurações", icon: ICONS.settings },
];

function resolveMeta(pathname) {
  if (pathname.includes("/wizard/")) {
    return { title: "Editar automação", subtitle: "Ajuste os elementos, o conteúdo e o agendamento." };
  }
  if (pathname.endsWith("/wizard")) {
    return { title: "Nova automação", subtitle: "Configure a automação completa em três passos." };
  }
  if (pathname.endsWith("/screens")) {
    return { title: "Telas do sistema", subtitle: "Cadastre e escaneie telas do sistema." };
  }
  if (pathname.endsWith("/automations")) {
    return { title: "Automações", subtitle: "Gerencie envios e monitore execuções." };
  }
  if (pathname.endsWith("/logs")) {
    return { title: "Histórico de envios", subtitle: "Acompanhe desempenho e erros." };
  }
  if (pathname.endsWith("/assets")) {
    return { title: "Assinaturas e imagens", subtitle: "Gerencie a galeria reutilizável." };
  }
  if (pathname.endsWith("/settings")) {
    return { title: "Configurações", subtitle: "SMTP, limites e parâmetros globais." };
  }
  return { title: "Automação de e-mails", subtitle: "Detecção inteligente e envio programado." };
}

export default function AutomacaoEmailsLayout({ onBack }) {
  const location = useLocation();
  const nav = useNavigate();
  const meta = resolveMeta(location.pathname);
  const isWizard = location.pathname.includes("/wizard");
  const isHome = location.pathname === "/automacao-emails" || location.pathname === "/automacao-emails/";
  const isScreens = location.pathname.endsWith("/screens");

  return (
    <div className="ae2-root">
      <aside className="ae2-sidebar">
        <button className="ae2-btn ae2-btn-glass ae2-sidebar-home" onClick={() => nav("/")}>
          {ICONS.back} Menu Inicial
        </button>

        <div className="ae2-sidebar-navwrap">
          <nav className="ae2-nav">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) => `ae2-nav-link ${isActive ? "active" : ""}`}
              >
                <span className="ae2-nav-icon">{item.icon}</span>
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>

      </aside>

      <div className="ae2-main">
        <header className="ae2-topbar">
          <div className="ae2-topbar-left">
            <div>
              <div className="ae2-top-title">{meta.title}</div>
              <div className="ae2-top-sub">{meta.subtitle}</div>
            </div>
          </div>
          <div className="ae2-topbar-actions">
            {!isWizard && !isHome && !isScreens && (
              <button className="ae2-btn ae2-btn-primary" onClick={() => nav("/automacao-emails/wizard")}> 
                {ICONS.plus} Nova automação
              </button>
            )}
          </div>
        </header>

        <main className="ae2-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
